import type { ReactNode } from "react"

import { SessionFileDownloadLink } from "./session-file-download-link"
import { resolveSandboxFileLink } from "../utils/sandbox-file-link"

type SandboxFileLinkProps = {
  assistantFiles: string[]
  children: ReactNode
  href: string | undefined
  sessionId: string
}

/** Validate a model-emitted sandbox href before rendering a download control. */
export function SandboxFileLink({
  assistantFiles,
  children,
  href,
  sessionId,
}: SandboxFileLinkProps) {
  const resolved = resolveSandboxFileLink(href, sessionId, assistantFiles)
  if (!resolved) return <span>{children}</span>

  return (
    <SessionFileDownloadLink filename={resolved.filename} fileUrl={resolved.fileUrl}>
      {children}
    </SessionFileDownloadLink>
  )
}
